import { Avatar, Box, Button, Grid, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import { toast } from 'react-toastify';
import { Icons } from '../../../../assets/SvgIcons';
import { TaskViewType } from '../../../../config/enum';
import { TaskType } from '../../../../config/task';
import { ComponentHelper } from '../../../../helper/Infra';
import { ICTask } from '../../../../helper/Interfaces';
import {
  getPlayBookDetail,
  postDealTaskList,
} from '../../../../store/feature/playBookDetailSlice';
import { getTaskHistory } from '../../../../store/feature/taskSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import NewTask from '../../NewTask/NewTask';
import TodoCard from '../../TodoCard/TodoCard';
import {
  getPersonalTemplatesDetail,
  postProjectTemplateDetailTask,
} from '@Store/feature/personalTemplatesDetailSlice';
import { useLocation } from 'react-router-dom';

type TaskDetailSubTaskProps = {
  allTasks: ICTask[];
  setAllTasks: (tasks: ICTask[]) => void;
  taskDetail: ICTask;
  updateSubTask: (task: ICTask[]) => void;
  setselectedSubTask: (task: ICTask) => void;
  selectedSubTask?: ICTask;
  setopenParentModal?: (click: boolean) => void;
  disabled?: boolean;
  isUserImo?: boolean;
  updateTask?: (currentTask: ICTask, username: string) => void;
};

const TaskDetailSubTask: FC<TaskDetailSubTaskProps> = ({
  allTasks,
  setAllTasks,
  isUserImo,
  taskDetail,
  updateSubTask,
  setselectedSubTask,
  setopenParentModal,
  selectedSubTask,
  disabled,
  updateTask,
}) => {
  const [createdTaskVisible, setCreatedTaskVisible] = useState<boolean>(false);
  const componentHelper = new ComponentHelper();
  const location = useLocation();

  let template = false;
  if (location.pathname.split('/')[1] === 'personal-templates-detail') {
    template = true;
  }

  const { selectedTask } = useAppSelector(getTaskHistory);
  const { tasks } = useAppSelector(getPersonalTemplatesDetail);
  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  const dispatch = useAppDispatch();
  const updateTaskName = async (currentTask: ICTask, taskName: string) => {
    const data = await componentHelper.updateTask({
      id: currentTask.id,
      name: taskName,
    });
    if (data.length > 0) {
      const newTaskList = [...dealTaskList];
      const index = dealTaskList.findIndex(emp => emp.id === data[0].id);
      const newVersion = { ...newTaskList[index] };
      newVersion.name = taskName;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
    }
  };

  const createSubTask = async (task: ICTask) => {
    let createdSubResponse = await componentHelper.createSubTask({
      name: task.name!,
      parentId: selectedTask?.id ?? '',
    });
    if (
      createdSubResponse.status &&
      (createdSubResponse.status === 201 || createdSubResponse.status === 200)
    ) {
      const newTask = createdSubResponse.data.taskDto as ICTask[];
      setAllTasks([...newTask]);

      let patchAllTasks = [...dealTaskList];
      if (template) {
        patchAllTasks = tasks;
      }
      let headerTask = patchAllTasks.find(
        i => i.id === newTask[0].parentId
      ) as ICTask;
      if (headerTask) {
        patchAllTasks = patchAllTasks.filter(i => i.id !== headerTask?.id!);
        const newHeaderTask = JSON.parse(JSON.stringify(headerTask)) as ICTask;
        newHeaderTask.subTaskCount = (newHeaderTask.subTaskCount ?? 0) + 1;
        patchAllTasks.push(newHeaderTask);
      }
      patchAllTasks = [...patchAllTasks, ...newTask];
      if (template) {
        dispatch(postProjectTemplateDetailTask([...patchAllTasks]));
      } else {
        dispatch(postDealTaskList([...patchAllTasks]));
      }
    } else {
      toast('There is an error while creating subtask');
    }
  };

  const getListStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? '#eee' : 'transparent',
  });

  const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    marginBottom: 10,
    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'grey',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const updateTaskProperty = async (
    taskId: string,
    taskProperty: string,
    value: any
  ) => {
    const updateTemplate = {
      id: taskId,
    };
    (updateTemplate as any)[taskProperty] = value;

    if (taskProperty === 'parentId') {
      const res = await componentHelper.changeParentTaskAndOrder(
        null,
        taskId,
        null,
        false
      );
      if (res.length && res.length > 0) {
        const changedTaskCollection = res as ICTask[];
        const legacyTaskList = JSON.parse(
          JSON.stringify(template ? tasks : dealTaskList)
        ) as ICTask[];
        let filteredTaskListList = [...legacyTaskList].filter(
          i => !changedTaskCollection.map(t => t.id).includes(i.id)
        );

        filteredTaskListList = [
          ...filteredTaskListList,
          ...changedTaskCollection,
        ];
        if (template) {
          dispatch(postProjectTemplateDetailTask([...filteredTaskListList]));
        } else {
          dispatch(postDealTaskList(filteredTaskListList));
        }
      }
      return;
    }

    const data = await componentHelper.updateTask(updateTemplate);
    if (data.errorCode) {
      toast(data?.message ?? 'Unknown Error');
      return;
    }
    if (data) {
      const newTaskList = template ? [...tasks] : [...dealTaskList];
      const index = dealTaskList.findIndex(emp => emp.id === data.id);
      const newVersion = { ...newTaskList[index] };
      (newVersion as any)[taskProperty] = value;
      newTaskList[index] = newVersion;
      if (template) {
        dispatch(postProjectTemplateDetailTask(newTaskList));
      } else {
        dispatch(postDealTaskList(newTaskList));
      }

      //setAllTasks([...newTaskList]);
    }
  };

  const handleDragEnd = async (dragEnd: DropResult) => {
    const { destination, draggableId } = dragEnd;
    if (!destination) {
      return;
    }

    const TaskId = draggableId;
    const SectionId = destination.index;

    const currentTask = allTasks.find(item => item.id === TaskId);
    const secondTask = allTasks[SectionId];

    if (currentTask) {
      const result = await componentHelper.changeFamilyOrder(
        currentTask.id ?? '',
        secondTask.id ?? '',
        (currentTask.orderNumber ?? 0) > (secondTask?.orderNumber ?? 0)
      );

      updateSubTask(result);
    }
  };

  const updateTaskDate = async (currentTask: ICTask, dueDate: string) => {
    const data = await componentHelper.updateTask({
      id: currentTask.id,
      dueDate: dueDate === '' ? null : dueDate,
    });
    if (data.length > 0) {
      const newTaskList = [...dealTaskList];
      const index = dealTaskList.findIndex(emp => emp.id === data[0].id);
      const newVersion = { ...newTaskList[index] };
      newVersion.dueDate = dueDate === '' ? null : dueDate;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
    }
  };

  return (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <div
        style={{
          display: 'flex',
          marginBottom: 20,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          variant="contained"
          className={`badgeButton readOnly`}
          sx={{
            bgcolor: '#F4F4F7',
            color: null,
          }}
          disabled
          startIcon={<Icons.SubTaskIcon color="#615E84" />}
          endIcon={
            <Avatar
              sx={{
                bgcolor: '#EBEBF0',
                width: 22,
                height: 19,
                fontSize: 11,
              }}
              variant="square"
            >
              <span
                style={{
                  fontSize: 11,
                  color: '#615E84',
                }}
              >
                {allTasks?.filter(task => !task.isArchived)?.length}
              </span>
            </Avatar>
          }
        >
          {taskDetail.type !== 'task' ? 'Action' : 'Subtasks'}
        </Button>
        {!(taskDetail.projectRelType === 'source' && !isUserImo) && (
          <Button
            className="custom-button-group sub-task"
            onClick={() => setCreatedTaskVisible(true)}
            disabled={disabled ?? false}
          >
            + Add new
          </Button>
        )}
      </div>
      <div>
        <DragDropContext onDragEnd={(e: DropResult) => handleDragEnd(e)}>
          <Droppable droppableId={`${taskDetail.id}`}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
                {...provided.droppableProps}
              >
                {allTasks
                  ?.filter(task => !task.isArchived)
                  ?.sort((a, b) => (a.orderNumber! > b.orderNumber! ? 1 : -1))
                  // ?.sort(
                  //   (a, b) => Number(a.isCompleted) - Number(b.isCompleted)
                  // )
                  .map((task, index) => (
                    <Draggable
                      key={task.id}
                      draggableId={task.id!}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <TodoCard
                            key={task.id}
                            task={task}
                            isFromList={true}
                            startDate={null}
                            subTaskCount={task.subTaskCount || 0}
                            subRiskCount={task.riskCount || 0}
                            subIssueCount={task.issueCount}
                            subDecisionCount={task.decisionCount || 0}
                            subDependencyCount={task.dependenciesCount || 0}
                            taskViewType={TaskViewType.LIST}
                            deleteTask={async (
                              currentTask: ICTask,
                              stopDelete?: string
                            ) => {
                              if (stopDelete === 'init') {
                                if (template) {
                                  dispatch(
                                    postProjectTemplateDetailTask(
                                      tasks.filter(
                                        task => task.id !== currentTask.id
                                      )
                                    )
                                  );
                                } else {
                                  dispatch(
                                    postDealTaskList(
                                      dealTaskList.filter(
                                        task => task.id !== currentTask.id
                                      )
                                    )
                                  );
                                }

                                const deleteResponse =
                                  await componentHelper.deleteTask(
                                    currentTask.id!
                                  );
                                localStorage.setItem(
                                  currentTask.id + 'delete',
                                  JSON.stringify(deleteResponse)
                                );
                              } else if (stopDelete === 'normal') {
                                console.log('normal');
                              } else if (stopDelete === 'break') {
                                await componentHelper.deleteUndoTask(
                                  currentTask.id!,
                                  JSON.parse(
                                    localStorage.getItem(
                                      currentTask.id + 'delete'
                                    ) ?? ''
                                  )
                                );
                                let patchAllTasks = template
                                  ? [...tasks]
                                  : [...dealTaskList];
                                let headerTask = patchAllTasks.find(
                                  i => i.id === task.parentId
                                );
                                if (headerTask) {
                                  patchAllTasks = patchAllTasks.filter(
                                    i => i.id !== headerTask?.id!
                                  );
                                  const newHeaderTask = JSON.parse(
                                    JSON.stringify(headerTask)
                                  ) as ICTask;
                                  if (task.type === 'subtask') {
                                    newHeaderTask.subTaskCount =
                                      newHeaderTask.subTaskCount
                                        ? newHeaderTask.subTaskCount - 1
                                        : newHeaderTask.subTaskCount;
                                  }

                                  patchAllTasks.push(newHeaderTask);
                                }
                                if (template) {
                                  dispatch(
                                    postProjectTemplateDetailTask([
                                      ...patchAllTasks,
                                      currentTask,
                                    ])
                                  );
                                } else {
                                  dispatch(
                                    postDealTaskList([
                                      ...patchAllTasks,
                                      currentTask,
                                    ])
                                  );
                                }
                              }
                            }}
                            updateTaskName={updateTaskName}
                            updateTask={updateTask}
                            updateTaskProperty={updateTaskProperty}
                            setopenParentModal={setopenParentModal}
                            selectedSubTask={setselectedSubTask}
                            disabled={disabled}
                            updateTaskDate={updateTaskDate}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      <div>
        {createdTaskVisible && (
          <NewTask
            setnewTaskVisible={setCreatedTaskVisible}
            taskType={TaskType.Task}
            taskViewType={TaskViewType.LIST}
            task={selectedTask as ICTask}
            createSubTask={createSubTask}
          />
        )}

        {allTasks?.filter(task => !task.isArchived).length < 1 && (
          <Grid container justifyContent="center">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
              }}
            >
              <Icons.NoTask width={270} height={142} />
              {['risk', 'issue'].includes(taskDetail.type ?? '') ? (
                <Typography>No further actions yet.</Typography>
              ) : (
                <Typography>No subtasks created yet.</Typography>
              )}
            </Box>
          </Grid>
        )}
        {!createdTaskVisible &&
          taskDetail.projectRelType !== 'source' &&
          taskDetail.type === 'dependency' && (
            <button
              className="addNewButtonLink"
              style={{
                marginLeft: 30,
                marginTop: 20,
                marginBottom: 20,
              }}
              onClick={() => {
                setCreatedTaskVisible(true);
              }}
              disabled={disabled ?? false}
            >
              + Add new{' '}
            </button>
          )}
      </div>
    </div>
  );
};

export default TaskDetailSubTask;
